import React from "react";
import styled from "styled-components";

const ErrorPage: React.FC = () => {
    return (
        <Container>
            <div>Error</div>
            <div>Oops! Looks like you've hit a wrong page!</div>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: 100vh;

    & > div:first-child {
        font-weight: 500;
        font-size: 36px;
    }
`;

export default ErrorPage;
